module.exports = __webpack_public_path__ + "img/UTSAND-2.f6f4ca43.jpg";